const PATTERNS = [/[A-Z]/, /[a-z]/, /\d/, /[~!#$%^&*()_+=<>'?]/];

const ldapRegex = /^[-a-zA-Zа-яА-Я0-9!@#$%^&*()_+=\[\]\/{};:"',.<>?]/;

const createLdapUserRegex = /^[-a-zA-Zа-яА-Я0-9!@#$%^&*()_+=-[~\]\/{};:"',.<>?]{6,}$/;

export const validatePassword = (ldapLogin, oldPass, password, onSuccess, onLengthError) => {
  if (ldapLogin) {
    const currentLdapRegex = oldPass ? ldapRegex : createLdapUserRegex;

    return currentLdapRegex.test(password);
  }

  if (password.length < 12) {
    return typeof onLengthError === 'function' ? onLengthError() : false;
  }

  const matches = PATTERNS.reduce((count, regex) => count + regex.test(password), 0);

  return onSuccess(matches);
};
